
import { IAccountFeesState } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import {
  onNgrxForms, onNgrxFormsAction, SetValueAction
} from 'ngrx-forms';
import { ResponseAction } from './actions';
import { AccountFeesModel } from 'src/app/model/account-fees.model';



export const loginState: IAccountFeesState = {
  model: new AccountFeesModel()
};

const reducer = createReducer(loginState,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResponseAction, (state, { payload }) => {
    return {
      ...state,
      model: payload
    };
  })
);

export function accountFeesReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}
